
import {Component, Prop, Vue} from 'vue-property-decorator';
import ScreenCanvas from "@/components/stead/store/screens/ScreenCanvas.vue";
import {ToyDocument, ToyHeavyDocument} from "@/models/tobject.model";
import {ScreenDocumentFlat} from "@/models/screen.model";

@Component({
  components: {ScreenCanvas}
})
export default class SbToyScreen extends Vue {
  // Les props
  @Prop({default: null}) private toy!: ToyDocument | ToyHeavyDocument | null

  // Les propriétés
  private size: number = 50

  // Les propriétés calculées
  private get screenData(): ScreenDocumentFlat | null {
    if (this.toy) {
      if (typeof this.toy.screen === 'string') {
        const scrid = this.toy.screen
        return this.$store.state.screen.screens.find((s: ScreenDocumentFlat) => s._id === scrid)
      } else {
        return this.toy.screen
      }
    }
    return null
  }

  private get urlShot() {
    if (this.toy) {
      const shotid = this.screenData ? this.screenData.screenshot : ''
      if (typeof this.toy.screen === 'string') {
        return this.$store.getters['screen/shotUrl'](shotid)
      } else {
        return this.$store.getters['step/shotUrl'](shotid)
      }
    }
    return ''
  }

  private get scrPath() {
    const packid = this.screenData ? this.screenData.packid : ''
    return this.$store.getters['screen/screenPath'](packid)
  }

  // Les hooks
  // Les méthodes surveillées
  // Les méthodes d'instance
  // Les méthodes statiques
}
